import React, { Component } from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router'
import { Container, Row, Col } from 'react-bootstrap'

import styles from './header.module.sass'

import logoIcon from '../../assets/icons/logo.png'
import hamburgerIcon from '../../assets/icons/hamburger.svg'
import closeIcon from '../../assets/icons/close.svg'

import routes from '../../config/routes'
import HeaderItem from './HeaderItem'
import ContactsModal from './ContactsModal'

export class Header extends Component {
  state = {}

  componentDidMount = () => {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  checkPath = path => this.props.location.pathname === path
  contactsHandler = () => this.setState({ isOpen: !this.state.isOpen })

  handleClickOutside = ({ target }) => {
    if (!target.closest('#contact__modal')) this.setState({ isOpen: false })
  }
  render() {
    const { isOpen, isMenuOpen } = this.state

    return (
      <Wrapper id="header">
        <Container>
          <Row style={{ height: 70, alignItems: 'center' }}>
            <Col xs={1} lg={1} onClick={() => this.props.history.push('/')}>
              <img
                onClick={() => this.props.history.push('/')}
                id="header-logo"
                height="50px"
                src={logoIcon}
                alt="Logo"
              />
            </Col>

            <Col xs={10} lg={{ span: 10, offset: 1 }}>
              <div className={styles.navigation}>
                {routes.map(({ path, title }) => (
                  <HeaderItem
                    path={path}
                    title={title}
                    key={path}
                    isActive={this.checkPath(path)}
                  />
                ))}
                <div
                  style={{ position: 'relative' }}
                  className={styles.navigation__item}>
                  <span onClick={this.contactsHandler}>Контакты</span>

                  <ContactsModal isOpen={isOpen} />
                </div>
              </div>

              <div className={styles.navigation__burger}>
                <div className={styles.navigation__burger__icon}>
                  <Icon
                    onClick={() => this.setState({ isMenuOpen: true })}
                    src={hamburgerIcon}
                  />
                </div>
                <div
                  className={
                    !isMenuOpen
                      ? styles.navigation__burger__body__close
                      : styles.navigation__burger__body
                  }>
                  {isMenuOpen && (
                    <div className={styles.navigation__burger__icon__close}>
                      <Icon
                        onClick={() => this.setState({ isMenuOpen: false })}
                        src={closeIcon}
                      />
                    </div>
                  )}

                  {routes.map(({ path, title }) => (
                    <HeaderItem
                      onClick={() => this.setState({ isMenuOpen: false })}
                      path={path}
                      title={title}
                      key={path}
                      isActive={this.checkPath(path)}
                    />
                  ))}

                  <ContactsModal
                    style={{
                      position: 'relative',
                      top: 0,
                      width: 250,
                    }}
                    isOpen={isOpen}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}

export default withRouter(Header)

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  background-color: rgba(100, 130, 156, 0.8);
  backdrop-filter: blur(20px);
  transition: all 0.2s;
`

const Icon = styled.img`
  width: 24px;
  height: 24px;
`
